export default __webpack_public_path__ + "static/media/window02.dc8090b3.png";